import { addFramesStyles, addMarginStyles, addTransition } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const StyledCollapse = styled.div`
	overflow: hidden;

	${addTransition()}

	${(p) => `
      ${addFramesStyles(p)} // do not use height on this component
      ${addMarginStyles(p)}

      height: ${p.height};

      opacity: ${p.height === 0 ? `0` : `1`};

      -webkit-tap-highlight-color: transparent;

      & > div {
        -webkit-tap-highlight-color: transparent;
      }
  `};
`;
